import React from 'react';
import {Map, Marker, Overlay} from "pigeon-maps";

import greenBus from '../img/green-bus.png'
import yellowBus from '../img/yellow-bus.png'
import redBus from '../img/red-bus.png'

const DefaultCenter = [50.035996, 21.964681];

export default function InitialMap({ markers = [], onMarkerClick, onMarkerClose }) {

    const sprawdzMiejscaIcon = (item) => {
        if (item.ileWoln === null) return 'fa-question-circle'
        if (item.ileWoln === 0) return 'fa-users'
        if (item.ileWoln === 1) return 'fa-male'
        if (item.ileWoln === 2) return 'fa-times'
    }

    const ileWolnych = (item) => {
        let icon = greenBus
        if (item.ileWoln === 1) {
            icon = yellowBus
        }
        if (item.ileWoln === 2) {
            icon = redBus
        }
        return icon
    }

    return (
        <Map  defaultCenter={DefaultCenter} defaultZoom={9}>
            {markers.map((marker, index) => {
                const position = [marker.szGps, marker.dlGps];

                return (
                    <Overlay anchor={position} key={index}>
                        <img
                            src={ileWolnych(marker)}
                            alt="custom-marker"
                            style={{ width: 32, height: 32, cursor: 'pointer' }}
                            onClick={() => onMarkerClick(marker)}
                        />
                    </Overlay>
                );
            })}

            {markers.map((marker, index) => (
                marker.showInfo && (
                    <Overlay anchor={[marker.szGps, marker.dlGps]} offset={[80, 90]} key={`popup-${index}`}>
                        <div
                            style={{
                                backgroundColor: 'white',
                                padding: '8px 12px',
                                borderRadius: '8px',
                                boxShadow: '0 0 8px rgba(0,0,0,0.3)',
                                maxWidth: 200,
                            }}
                        >
                            <div id="infowindow" style={{minWidth: 250}}>
                                <i className={"fa fa-times-circle"} onClick={() => onMarkerClose(marker)} title={'Zamknij'} style={{position: 'absolute', top: '0px', right: '2px', color: '#d43645', cursor: 'pointer'}}/>
                                <div style={{
                                    fontSize: '1rem',
                                    fontWeight: 'bold'
                                }}>{marker.nazTr.replace('-', ' - ')}</div>
                                <div className="row" style={{paddingTop: 5, width: '90%'}}>
                                    <div className="col-sm-12"><i className="fa fa-clock-o"/> Godzina
                                        startu: {marker.godz1p} </div>
                                    <div className="col-sm-12"><i
                                        className={"fa " + sprawdzMiejscaIcon(marker)}> </i>
                                        {marker.ileWoln === null ? ' Brak informacji' : null}
                                        {marker.ileWoln === 0 ? ' Wolne miejsca siedzące' : null}
                                        {marker.ileWoln === 1 ? ' Tylko miejsca stojące' : null}
                                        {marker.ileWoln === 2 ? ' Brak wolnych miejsc' : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Overlay>
                )
            ))}
        </Map>
    );
}



// WEBPACK FOOTER //
// ./src/components/mapaMarcel/InitialMap.js